<div class="text-a-right m-t-30">
    <button nz-button class="m-r-20" [nzType]="'primary'" translate (click)="downloadPDF()">Download</button>
    <!-- <button nz-button class="m-r-20" translate>Send</button> -->
    <button nz-button translate (click)="printReceipt('receipt')">Print</button>
</div>
<div id="receipt">
    <div class="title-emphasis">
        <i class="title-ico anticon anticon-file-protect" nz-icon nzType="file-done" nzTheme="outline"></i>
        <div>
            <h4 class="p-0 m-0">{{payloadData?.proposalDO?.proposalReceipts?.receiptNum}}</h4>
            <span class="col-grey-dark">Elon Musk</span>
        </div>
    </div>


    <div class="summary-container grid grid-3x grid-gap-20">
        <div>
            <span class="s-c-head" translate>Proposal No</span>
            <!-- <span>P0301083</span> -->
            <span >{{payloadData?.proposalDO?.proposalNum || '' | translate}}</span>
        </div>
        <div>
            <span class="s-c-head" translate>Policy No</span>
            <span> <span >{{payloadData?.proposalDO?.policyNum || '' | translate}}</span></span>
        </div>
        <div>
            <span class="s-c-head" translate>Plan</span>
            <span >{{payloadData?.proposalDO?.basePlan?.planOptionCd || '' | translate}}</span>
        </div>
        <div>
            <span class="s-c-head" translate>{{appMetadataHandler.SI_LABEL}}</span>
            <span>{{(payloadData?.proposalDO?.sumInsured  | CurrencyFormatter : (payloadData?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) || '' }}</span>
        </div>
        <div>
            <span class="s-c-head" translate>Payment Term</span>
            <span>{{payloadData?.proposalDO?.policyTerm || '' | translate}}</span>
        </div>
        <div>
            <span class="s-c-head" translate>Policy Status</span>
            <span>{{(payloadData?.proposalDO?.statusCd | technicalTranslate) || ''}}</span>
        </div>
        <div>
            <span class="s-c-head" translate>Risk Commencement Date</span>
            <span>{{(payloadData?.proposalDO?.proposalCoverageSchedules?.commencementDt | date:appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR)}}</span>
        </div>
        <div>
            <span class="s-c-head" translate>Payment Frequency</span>
            <span>{{payloadData?.proposalDO?.paymentFrequencyCd || '' | translate}}</span>
        </div>
    </div>

    <div>
        <h3 class="p-t-b-20 f-w-400 f-s-1r">Payment Details</h3>
        <nz-table nzSize="small" #paymentDataTable [nzData]="payloadData?.proposalDO?.proposalReceipts" [nzShowPagination]="false">
            <thead>
                <tr>
                    <th>Payment Mode</th>
                    <th>Payment Avenue</th>
                    <th>Date</th>
                    <th>Transaction ID</th>
                    <th>Amount Received</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of paymentDataTable.data">
                    <td>{{data?.paymentMethodCd}}</td>
                    <td>{{data?.paymentAvenueCd}}</td>
                    <td>{{(data?.transactionDt | date:appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR)}}</td>
                    <td>{{data?.payoutKey}}</td>
                    <td>{{(data?.amount | CurrencyFormatter : (data.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) )|| '-'}}</td>
                </tr>
            </tbody>
        </nz-table>
    </div>
    
    <div class="tab-grid m-t-20">
        <div>
            <span class="s-c-head" translate>Amount Due</span>
            <span>{{payloadData?.proposalDO?.dueAmt || '-' | translate}}</span>
        </div>
        <div>
            <span class="s-c-head" translate>Total Premium Payable</span>
            <span>{{payloadData?.proposalDO?.finalPremiumAmt || '-' | translate}}</span>
    
        </div>
        <div>
            <span class="s-c-head" translate>Actual Amount Paid</span>
            <span>{{payloadData?.proposalDO?.totPremPaidAmt || '-' | translate}}</span>
    
        </div>
        <div>
            <span class="s-c-head" translate>Notes</span>
            <span>{{payloadData?.proposalDO?.externalNotes || '-' | translate}}</span>
    
        </div>
    
    </div>
    

</div>